var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertbell8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4.55 10 5 9.55 5 9H3C3 9.55 3.45 10 4 10ZM7 7V4.5C7 2.965 6.185 1.68 4.75 1.34V1C4.75 0.585 4.415 0.25 4 0.25C3.585 0.25 3.25 0.585 3.25 1V1.34C1.82 1.68 1 2.96 1 4.5V7L0 8V8.5H8V8L7 7ZM6 7.5H2V4.5C2 3.26 2.755 2.25 4 2.25C5.245 2.25 6 3.26 6 4.5V7.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertbell8);
export default __webpack_public_path__ + "97120/static/media/alertbell8.6cbdc5b09b32a5d52aeeeb71fc3bf805.svg";
export { ForwardRef as ReactComponent };